import { render, staticRenderFns } from "./UnitsMeasure.vue?vue&type=template&id=4d89a4d6"
import script from "./UnitsMeasure.vue?vue&type=script&lang=js"
export * from "./UnitsMeasure.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports